// 处理盘库信息
export function SET_PK_LIST(data) {
  if (data) {
    if ('PRODUCT_DATA' in data) {
      const products = data.PRODUCT_DATA.map((item) => {
        item.PK_WORTH = Math.round((item.PRODUCT_COUNT * item.PRODUCT_PRICE) * 100) / 100;
        item.CURRENT_COUNT = Number(item.PRODUCT_COUNT);
        item.PK_COUNT = Number(item.PRODUCT_COUNT);
        item.WARE_COUNT = Number(item.PRODUCT_COUNT);
        item.BEFORE_WORTH = Number(item.BEFORE_WORTH);
        return item;
      });
      return products;
    }
    // 修改商品盘库数量和盘库后价值
    const products = data.PRODUCT_DATA.map((item) => {
      item.PK_WORTH = Math.round((item.PRODUCT_COUNT * item.PRODUCT_PRICE) * 100) / 100;
      item.CURRENT_COUNT = Number(item.PRODUCT_COUNT);
      item.WARE_COUNT = Number(item.PRODUCT_COUNT);
      item.PK_COUNT = Number(item.PRODUCT_COUNT);
      return item;
    });
    return products;
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/PK.js